import {
    Button,
    ColorPicker,
    Divider,
    Form,
    Modal,
    Segmented,
    Switch,
    Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { ThemeColorPicker } from "../qmade/creator/GSBox";
import {
    ArrowRightOutlined,
    CloseOutlined,
    PlusOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import QurealOneViewer from "../showwrapper/QurealOneViewer";
import { useThemeGenerator, useThemeGeneratorFromLogo } from "../_actions/bot";
import log from "cslog";
import ImagePicker from "../editor/imagepicker/ImagePicker"; //imported the new image panel
import { getImageFileURL, getImageURL } from "../_helpers/image";

const DEMO_CREATIONS = [
    // "singlepage_zFuOWtN_dEnrU",
    // "singlepage_8RakzPl_yYVzB",
    // "singlepage__zTu0oX_EfM3F",
    // "singlepage_UQpYTeR_FlN7E",
    "singlepage_8jNfI",
    "singlepage_PQgvV_copy_mLrCA_copy_wiIOG",
    "singlepage_9UglU_copy_IYaCs_copy_PXgaQ_copy_bYyID",
    "singlepage_Pxy2V_copy_UpA0S_copy_JIO49",
    "singlepage_xjIw0_copy_RFX0f_copy_2K9MH",
    "singlepage_gPwvb_copy_Seg96",
    "singlepage_nFgaT_copy_lSOKG_copy_GoToy",
    "singlepage_UZyEm_copy_Jxh2B",
    "adfs",
    "dfsdf",
];

const DEMO_AYUSHI_CREATIONS = [
    "singlepage_8jNfI_copy_tbAEU",
    "singlepage_PQgvV_copy_mLrCA",
    "singlepage_9UglU_copy_IYaCs_copy_PXgaQ",
    "singlepage_Pxy2V_copy_UpA0S",
    "singlepage_xjIw0_copy_RFX0f",
    "singlepage_gPwvb",
    "singlepage_nFgaT_copy_lSOKG",
    "singlepage_UZyEm_copy_Jxh2B_copy_t5S2u",
    "singlepage_jnC1U",
    "singlepage_v5tgq",
];

function ThemeGenerator({ trigger, value = [], onChange = () => {} }) {
    const [open, setOpen] = useState(false);
    const [theme, setTheme] = useState({});
    const [themes, setThemes] = useState([]);
    const [theme_index, setThemeIndex] = useState(0);
    const [current_index, setCurrentIndex] = useState(0);

    log.d(themes, "themes in TG");

    return (
        <>
            <span onClick={() => setOpen(true)}>{trigger}</span>
            <Modal
                title="Theme Generator"
                open={open}
                onCancel={() => setOpen(false)}
                width={700}
                // footer={null}
                okText="Proceed"
                onOk={() => {
                    onChange(themes);
                    setOpen(false);
                }}
                okButtonProps={{
                    disabled: themes?.length === 0,
                }}
            >
                {/* <pre>{JSON.stringify(themes, null, 2)}</pre> */}

                <ThemeGeneratorCore
                    theme={theme}
                    setTheme={setTheme}
                    themes={themes}
                    setThemes={setThemes}
                    setThemeIndex={setThemeIndex}
                    value={value}
                />

                <div
                    style={{
                        width: "450px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "15px",
                    }}
                >
                    <Form layout="vertical">
                        <ThemeColorPicker
                            // theme={theme}
                            value={theme}
                            onChange={setTheme}
                            initial_theme={theme}
                        />
                    </Form>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div>
                        <Button
                            onClick={() => setCurrentIndex(current_index - 1)}
                            disabled={current_index === 0}
                        >
                            Prev
                        </Button>
                        <Button
                            onClick={() => setCurrentIndex(current_index + 1)}
                            disabled={
                                current_index === DEMO_CREATIONS.length - 1
                            }
                        >
                            Next
                        </Button>
                    </div>
                    {/* <Segmented
                        options={["shivam", "ayushi"]}
                        value={person}
                        onChange={setPerson}
                    /> */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                        }}
                    >
                        Palette
                        <Button
                            onClick={() => {
                                setTheme(themes[theme_index - 1]);
                                setThemeIndex(theme_index - 1);
                            }}
                            disabled={theme_index === 0}
                        >
                            {"<"}
                        </Button>
                        <p>{theme_index + 1}</p>
                        <Button
                            onClick={() => {
                                setTheme(themes[theme_index + 1]);
                                setThemeIndex(theme_index + 1);
                            }}
                            disabled={
                                theme_index === themes.length - 1 ||
                                themes?.length === 0
                            }
                        >
                            {">"}
                        </Button>
                    </div>
                </div>

                <div
                    style={{
                        width: "650px",
                        height: "650px",
                        marginTop: "15px",
                    }}
                >
                    <QurealOneViewer
                        // slug="singlepage__zTu0oX_EfM3F"
                        slug={DEMO_AYUSHI_CREATIONS[current_index]}
                        type="creation"
                        creation_type="singlepage"
                        preview={true}
                        fit={true}
                        isMobile={false}
                        gs_overrides={{
                            config: theme,
                        }}
                        organization="qureal@qureal.com"
                        style={{
                            width: "650px",
                            height: "650px",
                            border: "1px solid black",
                        }}
                        loadingRender={
                            <div
                                style={{
                                    width: "650px",
                                    height: "650px",
                                }}
                            >
                                Loading...
                            </div>
                        }
                    />
                </div>
            </Modal>
        </>
    );
}

export default ThemeGenerator;

export function ThemeGeneratorCore({
    theme,
    setTheme,
    themes,
    setThemes,
    setThemeIndex = () => {},
    value = [],
}) {
    const [brand_color, setBrandColor] = useState("#ccaa22");
    const [second_brand_color, setSecondBrandColor] = useState(null);
    const [is_local, setIsLocal] = useState(false);
    const [logo, setLogo] = useState(null);

    const mutation = useThemeGenerator(is_local, (result) => {
        log.d(result, "Result");
        if (result?.success) {
            if (Array.isArray(result?.data)) {
                setThemes(result?.data);
                setTheme(result?.data[0]);
                setThemeIndex(0);
            } else {
                setTheme(result?.data);
            }
        }
    });
    const mutationLogo = useThemeGeneratorFromLogo(is_local, (result) => {
        log.d(result, "Result logo color");
        if (result?.success) {
            if (Array.isArray(result?.data)) {
                setThemes(result?.data);
                setTheme(result?.data[0]);
                setThemeIndex(0);
                // setBrandColor(result?.data[0]?.secondryColor);
            } else {
                setTheme(result?.data);
            }
        }
    });

    useEffect(() => {
        // setCurrentIndex(0);
        const new_col = getRandomColor();
        setBrandColor(new_col);
        if (value?.length > 0) {
            setThemes(value);
            setTheme(value[0]);
            setThemeIndex(0);
        } else if (!mutation.isLoading) {
            mutation.mutate({
                // colors: [brand_color, null],
                colors: [new_col, null],
            });
        }
    }, []);

    return (
        <div
            style={{
                display: "flex",
                gap: "10px",
                paddingTop: "20px",
                paddingBottom: "30px",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    alignItems: "flex-start",
                    borderRight: "1px solid #ddd",
                    paddingRight: "15px",
                }}
            >
                <ColorPicker
                    value={brand_color}
                    onChange={(new_col) => setBrandColor(`#${new_col.toHex()}`)}
                    showText
                    style={{
                        width: "160px",
                        justifyContent: "flex-start",
                    }}
                />
                <div
                    style={{
                        display: "flex",
                        gap: "5px",
                    }}
                >
                    <ColorPicker
                        value={second_brand_color}
                        onChange={(new_col) =>
                            setSecondBrandColor(`#${new_col.toHex()}`)
                        }
                        showText
                        style={{
                            width: "123px",
                            justifyContent: "flex-start",
                        }}
                    />
                    <Button
                        icon={<CloseOutlined />}
                        onClick={() => setSecondBrandColor(null)}
                    />
                </div>

                <div
                    style={{
                        display: "flex",
                        gap: "5px",
                    }}
                >
                    <Button
                        type="primary"
                        icon={<ArrowRightOutlined />}
                        iconPosition="end"
                        onClick={() => {
                            mutation.mutate({
                                colors: second_brand_color
                                    ? [brand_color, second_brand_color]
                                    : [brand_color, null],
                            });
                            setLogo(null);
                        }}
                        loading={mutation.isLoading || mutationLogo.isLoading}
                        style={{ width: "123px" }}
                    >
                        Generate
                    </Button>
                    <Button
                        type="primary"
                        icon={<SyncOutlined />}
                        onClick={() => {
                            const new_col = getRandomColor();
                            setBrandColor(new_col);
                            mutation.mutate({
                                colors: [new_col, null],
                            });
                        }}
                        loading={mutation.isLoading || mutationLogo.isLoading}
                    ></Button>
                </div>
            </div>
            <div>
                <ImagePicker
                    // trigger={<Button size="medium">Select Logo</Button>}
                    trigger={
                        <>
                            {logo?.id ? (
                                <img
                                    src={getImageURL(logo?.id)}
                                    style={{
                                        height: "100px",
                                        objectFit: "contain",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                    }}
                                />
                            ) : (
                                <button
                                    style={{
                                        width: "100px",
                                        height: "100px",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                        background: "#eee7",
                                        cursor: "pointer",
                                    }}
                                    type="button"
                                >
                                    <PlusOutlined />

                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </button>
                            )}
                        </>
                    }
                    many={false}
                    defaultTab="collection"
                    onSelect={(images) => {
                        const one = images[0];
                        log.d(one, "selected image");
                        mutationLogo.mutate({
                            id: one?.id,
                            by: "ai",
                        });
                        setLogo(one);
                    }}
                />
            </div>

            {/* 
<Switch
    checkedChildren="Local"
    unCheckedChildren="Remote"
    value={is_local}
    onChange={setIsLocal}
/> 
*/}
        </div>
    );
}

function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
